"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import DateFormat from "@/framework/timeformatter";
import { ShopDetailModel } from "@/models/virtual-shop/ShopDetail.model";
let LoginLog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource(`api://base.auth/api/v8/shops/login_message_log`)
    );
  }
  created() {
    return __async(this, null, function* () {
      this.gridController.pagePosition = "dialog";
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.search();
    });
  }
  search() {
    return __async(this, null, function* () {
      this.gridController.query.params = {
        search: {
          shop_id: this._shopId
        }
      };
      this.gridController.search();
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
};
__decorateClass([
  PropSync("shopDetailData", {
    type: ShopDetailModel,
    default: () => {
      return new ShopDetailModel();
    }
  })
], LoginLog.prototype, "_shopDetailData", 2);
__decorateClass([
  PropSync("shopId", {
    type: String,
    default: () => {
      return "";
    }
  })
], LoginLog.prototype, "_shopId", 2);
LoginLog = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], LoginLog);
export {
  LoginLog as default
};
